import CheckoutPrice from 'domains/customer-checkout/molecules/price'
import PropTypes from 'prop-types'

/**
   * Convert error messages to array of string
   * @param {object} errorMessages - object of error messages
   * @returns {array} array of error message string
   */
const convertErrorMessageToArray = (errorMessages) => {
  let arrayOfErrorMessages = []

  Object.values(errorMessages).forEach((errorArray) => {
    arrayOfErrorMessages = arrayOfErrorMessages.concat(errorArray)
  })

  return arrayOfErrorMessages
}

const CustomerCheckoutShipmentMethod = ({ shipmentMethod }) => {

  const errorMessages        = shipmentMethod ? shipmentMethod?.error_messages : {}
  const isEmptyErrorMessage  = Object.keys(errorMessages).length === 0
  const arrayOfErrorMessages = isEmptyErrorMessage ? [] : convertErrorMessageToArray(errorMessages)

  const showShipmentcost = shipmentMethod?.cost > 0

  const ShipmentMethodDefault = () => (
    <div className='d-flex align-items-center'>
      <strong>Pilih Ongkir</strong>
    </div>
  )

  const ShipmentMethodSelected = ({ shipmentMethod }) => (
    <div className='small'>
      <div className={ `font-weight-bold text-capitalize ${!isEmptyErrorMessage && 'text-gray'}` }>{ shipmentMethod.courier } ({ shipmentMethod.service_display })</div>
      <div>
        {
          shipmentMethod.etd_from === shipmentMethod.etd_thru
            ? `${shipmentMethod.etd_thru} ${shipmentMethod.time_unit}`
            : `${shipmentMethod.etd_from}-${shipmentMethod.etd_thru} ${shipmentMethod.time_unit}`
        }
      </div>
      { showShipmentcost && <CheckoutPrice price={ shipmentMethod.cost } /> }

      {
        arrayOfErrorMessages.map((errorMsg, index) => (
          <div key={ `${shipmentMethod.courier}-error-${index}` }>
            <small  className='text-danger font-weight-bold'>
              { `* ${errorMsg}` }
            </small>
            <br />
          </div>
        ))
      }

      {
        shipmentMethod.service_type == 'RGSCOD'
          ? <div className='text-secondary'>Payment method akan automatis ubah ke COD</div>
          : null
      }
    </div>
  )

  return (
    shipmentMethod
      ? <ShipmentMethodSelected shipmentMethod={ shipmentMethod } />
      : <ShipmentMethodDefault />
  )
}

CustomerCheckoutShipmentMethod.defaultProps = {
  shipmentMethod: {
    courier         : 'Default Courier Name',
    service_display : 'Default Service Display',
    service_type    : 'default_service_type',
    etd_from        : -1,
    etd_thru        : -1,
    cost            : -100000,
    error_messages  : {},
    time_unit       : 'day'
  }
}

CustomerCheckoutShipmentMethod.propTypes = {
  shipmentMethod: PropTypes.shape({
    courier         : PropTypes.string,
    service_display : PropTypes.string,
    service_type    : PropTypes.string,
    etd_from        : PropTypes.number,
    etd_thru        : PropTypes.number,
    cost            : PropTypes.number,
    error_messages  : PropTypes.object,
    time_unit       : PropTypes.string
  })
}

export default CustomerCheckoutShipmentMethod